export default class InitFormFileInput{

	constructor(parentSelector=''){
		this.cache = {
			input: 		$(`${parentSelector}.form__input`),
		};

		/**
		 * Initalise Class Functions
		//  */

		this.handleInputFile();
	}

	handleInputFile(){
		$(document).ready(function(){
			$('.form__input').find('input:file').each(function(index, self){
				const title =  $(self).closest('.form__input').find('.sq-form-question-title').text()
				$(self).closest('.form__input').find('.sq-form-question-title').hide()
				$(self).closest('.sq-form-upload-wrapper').addClass('form__input--file-wrapper')
				$(self).closest('.form__input').before(`<h4>${title}</h4>`)
				$(self).wrap("<label class='form__input--file'>Select file</label>")
				$(self).closest('.sq-form-upload-wrapper').append('<span class="secondary form__input--file-name">No file attached</span>')

				$(self).on('change', function(){
					var name = $(self)[0].value.split('\\').pop()
					$(self).closest('.form__input').find('.form__input--file-name').html(name)
				})
			}.bind(this))
		})
	}
}
